import React, { useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import "./style.css";
import SearchIcon from "../../../../components/icons/SearchIcon";

function SearchModal(props) {
  const [dis, setDis] = useState(false);
  const dropdownRef = useRef(null);
 const handleClose = () => {
    props.setPaymentOpen(false);
  };
    const handleAgree = () => {
    props.handleCompanyDownload();
    props.setPaymentOpen(false);
  };
  return (
    <div className="payment-modal-parent">
      <Modal
        {...props}
        show={props.paymentOpen}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="payment-modall search-modal">
          <Modal.Title
            id="contained-modal-title-vcenter w-100"
            style={{ width: "100% !important" }}
          >
            <div className="search-new w-100" ref={dropdownRef}>
              <input
                type="text"
                className="form-control custom-placeholder"
                style={{ paddingLeft: "50px" }}
                placeholder="Search here"
                value={props?.searchQuery}
                onChange={props?.handleSearchChange}
                autoFocus
              />

              <button
                type="button"
                className="btn position-absolute top-50 translate-middle-y"
                style={{ left: "10px", padding: "5px", fontSize: "12px" }}
                // onClick={handleSearchToggle}
              >
                <SearchIcon />
              </button>
            </div>
          </Modal.Title>
        </Modal.Header>
        <div style={{ maxHeight: "250px" }}>
          <Modal.Body>
            <div>
              {props?.searchResults?.length > 0 ? (
                <>
                  {props?.searchResults?.map((result, i) => (
                    <div
                      className="text-primary mb-2"
                      onClick={() => props.handleResultClick(result)}
                      style={{ cursor: "pointer" }}
                    >
                      {i + 1}. {result?.name}
                    </div>
                  ))}
                </>
              ) : (
                <div>
                  <div
                  >
                    Search results will appear here
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={ handleClose}>Close</Button>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
}

export default SearchModal;
